(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rtc-shop-highlights"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('rtc-shop-highlights')) {
  customElements.define('rtc-shop-highlights', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = {signal:this.controller.signal};
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-dot]'));
      this.position = 0;
      this.playing = this.dataset.autoplay === 'true' && !matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.interval = Math.max(6000, Number(this.dataset.interval) || 7000);
      this.status = this.querySelector('[data-status]');
      this.playButton = this.querySelector('[data-play]');
      this.querySelector('[data-controls]')?.removeAttribute('hidden');
      this.querySelector('[data-next]')?.addEventListener('click', () => this.move(1, true), options);
      this.querySelector('[data-prev]')?.addEventListener('click', () => this.move(-1, true), options);
      this.dots.forEach((dot,index) => dot.addEventListener('click', () => {this.stop();this.show(index);}, options));
      this.addEventListener('shopify:block:select', event => {const slide = event.target.closest('[data-slide]');if (slide && this.slides.includes(slide)) {this.stop();this.show(this.slides.indexOf(slide));}}, options);
      this.playButton?.addEventListener('click', () => {this.playing = !this.playing;this.refresh();}, options);
      this.addEventListener('mouseenter', () => {this.hovered = true;this.clear();}, options);
      this.addEventListener('mouseleave', () => {this.hovered = false;this.refresh();}, options);
      this.addEventListener('focusin', event => {if (event.target !== this.playButton) this.stop();}, options);
      document.addEventListener('visibilitychange', () => this.refresh(), options);
      this.observer = new IntersectionObserver(entries => {this.visible = entries[0].isIntersecting;this.refresh();});
      this.observer.observe(this);
      this.show(0);
    }
    show(index) {
      if (!this.slides.length) return;
      this.position = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide,i) => {slide.hidden = i !== this.position;});
      this.dots.forEach((dot,i) => dot.setAttribute('aria-current', String(i === this.position)));
      if (this.status) this.status.textContent = this.slides[this.position].getAttribute('aria-label');
      this.refresh();
    }
    move(direction,manual) {
      if (manual) this.stop();
      this.show(this.position + direction);
    }
    stop() {this.playing = false;this.refresh();}
    clear() {clearInterval(this.timer);this.timer = null;}
    refresh() {
      this.clear();
      if (this.playButton) {
        this.playButton.setAttribute('aria-label', this.playing ? this.dataset.pauseLabel : this.dataset.playLabel);
        this.playButton.querySelector('[data-play-icon]').textContent = this.playing ? 'Ⅱ' : '▶';
      }
      if (this.status) this.status.setAttribute('aria-live', this.playing ? 'off' : 'polite');
      if (this.playing && this.visible && !this.hovered && !document.hidden && this.slides.length > 1) this.timer = setInterval(() => this.move(1, false), this.interval);
    }
    disconnectedCallback() {this.clear();this.observer?.disconnect();this.controller?.abort();this.controller = null;}
  });
}

  } catch(e) { console.error(e); }
})();
})();
